import config from 'src/config';

function Ctrl($scope, $stateParams, $uibModalInstance, input, $location, jsSdkConfig, partnerService, $window) {
  $scope.venue = input.venue;
  $scope.inventoryId = input.inventory;

  setTimeout(() => {
    const inventoryListWidget = new window.TablelistWidgets.widgets.InventoryListWidget('#inventory-list-modal-widget');

    inventoryListWidget.init({
      venueId: $scope.venue.id,
      inventoryId: $scope.inventoryId,
      date: input.startDate,
      client: $location.search().client || 'web',
      theme: 'theme-light',
      attributionId: jsSdkConfig.attributionId,
      attributionType: jsSdkConfig.attributionType,
      disableInlineCheckout: true,
      checkoutUrl: config.NODE_ENV === 'local' ? 'http://localhost:9090/buy' : null,
      onInventoryAddedToCart(inventory) {
        if (config.NODE_ENV === 'production') {
          const fbqData = {
            content_type: 'product',
            value: inventory.price,
            currency: 'USD',
            content_ids: [
              inventory.venue
            ],
            referrer: document.referrer,
            userAgent: navigator.userAgent,
            language: navigator.language
          };

          $window.fbq('init', '1606722376242558');
          $window.fbq('trackSingle', '1606722376242558', 'AddToCart', fbqData);
          $window.fbq('init', '316401409092218');
          $window.fbq('trackSingle', '316401409092218', 'AddToCart', fbqData);
        }
      }
    });
  }, 300);

  $scope.$on('widget-checkout', function() {
    $uibModalInstance.close();
  });

  $scope.cancel = function($event) {
    if ($event) $event.preventDefault();

    $uibModalInstance.dismiss('cancel');
  };
}

Ctrl.$inject = [
  '$scope',
  '$stateParams',
  '$uibModalInstance',
  'input',
  '$location',
  'jsSdk.config',
  'partnerService',
  '$window'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/services/modal/bookingWidget/bookingWidgetModalCtrl.js